module.exports = __webpack_public_path__ + "img/brick-house.07378129.png";